import { EAffiliateCouponType } from "@devowl-wp/api-real-commerce";
import { Empty, Table, Tooltip } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useStores } from "../../../../store";
import { __ } from "../../../../utils";
import { AccountAffiliateCouponActions } from ".";
import { QuestionCircleOutlined } from "@ant-design/icons";
const {
  Column
} = Table;
const AccountAffiliateCouponsTable = observer(() => {
  const {
    accountStore
  } = useStores();
  const {
    session: {
      affiliate
    },
    busyAffiliateProducts
  } = accountStore;
  const {
    busyCoupons: busy,
    coupons
  } = affiliate;
  useEffect(() => {
    affiliate.fetchCoupons();
  }, [affiliate]);
  return /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    locale: {
      emptyText: /*#__PURE__*/React.createElement(Empty, {
        description: __("You have not yet created a coupon.")
      })
    },
    loading: busy || busyAffiliateProducts,
    pagination: false,
    dataSource: Array.from(coupons.values()),
    rowKey: row => row.data.id,
    size: "small"
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("Coupon"),
    dataIndex: "code",
    key: "code",
    render: (_, _ref) => {
      let {
        data: {
          code
        }
      } = _ref;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("code", null, code));
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Products"),
    dataIndex: "products",
    key: "products",
    render: (_, _ref2) => {
      let {
        data: {
          products
        }
      } = _ref2;
      return products.map(_ref3 => {
        let {
          name
        } = _ref3;
        return name;
      }).join(", ");
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Discount"),
    dataIndex: "discount",
    key: "discount",
    render: (_, _ref4) => {
      let {
        data: {
          discountAmount,
          discountType
        }
      } = _ref4;
      return `${discountAmount} ${discountType === EAffiliateCouponType.Flat ? "EUR" : "%"}`;
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: /*#__PURE__*/React.createElement(Tooltip, {
      title: __("Specifies whether the coupon created is valid only for the invoicing first period of a booked subscription, or whether the customer also saves on recurring payments (for example, in the second year).")
    }, __("Recurring"), " ", /*#__PURE__*/React.createElement(QuestionCircleOutlined, null)),
    dataIndex: "recurring",
    key: "recurring",
    render: (_, _ref5) => {
      let {
        data: {
          isRecurring
        }
      } = _ref5;
      return isRecurring ? __("Yes") : __("No");
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Actions"),
    dataIndex: "actions",
    key: "actions",
    align: "right",
    render: (_, record) => /*#__PURE__*/React.createElement(AccountAffiliateCouponActions, {
      record: record
    })
  }));
});
export { AccountAffiliateCouponsTable };